"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Command = void 0;
var Command;
(function (Command) {
    Command["UNKNOWN"] = "UNKNOWN";
    /**
     * 心跳
     */
    Command["HEART_BEAT"] = "HEART_BEAT";
    /**
     * 登陆房间
     */
    Command["CLIENT_READY"] = "CLIENT_READY";
    /**
     * 光标协同
     */
    Command["CURSOR_MESSAGE"] = "CURSOR_MESSAGE";
    /**
     * 用户进入房间
     */
    Command["USER_NEWINFO"] = "USER_NEWINFO";
    /**
     * 多个用户进入了房间
     */
    Command["USER_NEWINFOS"] = "USER_NEWINFOS";
    /**
     * 用户离开房间
     */
    Command["USER_LEAVE"] = "USER_LEAVE";
    /**
     * 多个用户离开房间
     */
    Command["USER_LEAVES"] = "USER_LEAVES";
    /**
     * 退出踢人
     */
    Command["QUIT_NOTICE"] = "QUIT_NOTICE";
    /**
     * 用户编辑内容
     */
    Command["USER_CHANGES"] = "USER_CHANGES";
    /**
     * Server推送协同消息
     */
    Command["NEW_CHANGES"] = "NEW_CHANGES";
    /**
     * Server已落盘成功
     */
    Command["ACCEPT_COMMIT"] = "ACCEPT_COMMIT";
    /**
     * 获取权限
     */
    Command["GET_PRIVILEGE"] = "GET_PRIVILEGE";
    /**
     * 进入大协同模式
     */
    Command["BIG_COLLAB_SWITCH"] = "BIG_COLLAB_SWITCH";
    /**
     * 使用通用CGI请求
     */
    Command["COMMON_REQUEST"] = "COMMON_REQUEST";
    /**
     * BIND_POST请求
     */
    Command["BIND_POST"] = "BIND_POST";
    /**
     * bind 请求断连
     */
    Command["CLIENT_DISCONNECT"] = "CLIENT_DISCONNECT";
    /**
     * 远程演示控制消息
     */
    Command["LIVE_MESSAGE"] = "LIVE_MESSAGE";
    /**
     * 更新token信息
     */
    Command["UPDATE_WEBOFFICE_TOKEN"] = "UPDATE_WEBOFFICE_TOKEN";
})(Command || (Command = {}));
exports.Command = Command;
